import type { Networkish } from "@/types";
import type { Abi, Address } from "viem";

import useApi from "@/hooks/api/useApi";

/**
 * Fetch mainnet superform's smart-contracts with the meta-data
 * @todo: figure out all possible ways to secure it
 *
 * @api {{GET}} /deployment
 */
interface ResponseDeployment {
  deployments: SupWeb3ConfigNetwork[];
  router_abi: Abi;
}

export interface SupWeb3ConfigNetwork {
  ChainID: Networkish;
  CelerImplementation: Address;
  CoreStateRegistry: Address;
  ERC4626Form: Address;
  ERC4626KYCDaoForm: Address;
  ERC4626TimelockForm: Address;
  FactoryStateRegistry: Address;
  HyperlaneImplementation: Address;
  LayerzeroImplementation: Address;
  LiFiValidator: Address;
  MultiTxProcessor: Address;
  PayMaster: Address;
  PayloadHelper: Address;
  PaymentHelper: Address;
  SocketValidator: Address;
  SuperPositions: Address;
  VaultClaimer: Address;
  SuperRBAC: Address;
  SuperRegistry: Address;
  SuperTransmuter: Address;
  SuperformFactory: Address;
  SuperformRouter: Address;
  TwoStepsFormStateRegistry: Address;
  RouterAbi: Abi;
}

/**
 * @package api:go
 * @link https://superform-xyz.postman.co/workspace/Superform~fe57d318-f198-4f97-9c50-0b2a5a78dbac/request/3472327-52bfdf8e-7555-4de5-b1c7-5e82b43f1444?ctx=documentation
 */
export default function useDeployment() {
  const { data, isLoading, isError, error } = useApi<SupWeb3ConfigNetwork[], ResponseDeployment>(
    {
      path: `/deployment/`,
      api: "v2",
    },
    {
      strategy: "cached",
      select: (data: ResponseDeployment) => {
        return data.deployments.map((deployment: SupWeb3ConfigNetwork) => {
          return {
            ...deployment,
            RouterAbi: data.router_abi as Abi,
          };
        });
      },
    }
  );

  return {
    data,
    isLoading,
    isError,
    error,
  };
}
